import React from 'react';

function FileWatchingContent() {
  return (
    <>
      <p>RepoPrompt automatically monitors your workspace folders for changes, ensuring the file tree always reflects the current state of your project.</p>
      
      <h3>Automatic File System Watching</h3>
      <p>With file watching, RepoPrompt detects and reflects the following changes automatically:</p>
      <ul>
        <li><strong>File additions:</strong> New files appear in the file tree</li>
        <li><strong>File deletions:</strong> Removed files disappear from the tree</li>
        <li><strong>File modifications:</strong> Changed files are updated in selections</li>
        <li><strong>Renames:</strong> Renamed files are updated in the file tree</li>
        <li><strong>Folder structure changes:</strong> Moved or new folders are reflected</li>
      </ul>
      
      <h3>Benefits of File Watching</h3>
      <ul>
        <li>Seamlessly work between RepoPrompt and your code editor</li>
        <li>No need to manually refresh when files change</li>
        <li>Always work with the most current version of your code</li>
        <li>Changes made through the AI's suggestions are immediately available for next prompts</li>
      </ul>
      
      <h3>Manual Refresh</h3>
      <p>While rarely needed due to automatic watching, a manual refresh option is available:</p>
      <ol>
        <li>Locate the "Refresh" button (circular arrow icon) above the file tree</li>
        <li>Click this button to force RepoPrompt to rescan your workspace folders</li>
      </ol>
    </>
  );
}

export default FileWatchingContent;